import { WithClassName } from '@types';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { Link } from 'react-router';

interface NavItemProps {
  link: string;
  selected: boolean;
}

const NavItem = ({
  children,
  className,
  link,
  selected,
}: NavItemProps & WithClassName & PropsWithChildren) => {
  const itemClassName = classNames(
    'grow basis-0 flex items-center flex-wrap leading-4.5 lowercase text-nowrap transition-colors duration-300 hover:text-accent',
    selected && 'text-accent',
    className,
  );

  return link ? (
    <Link className={itemClassName} to={link}>
      {children}
    </Link>
  ) : (
    <div className={itemClassName}>{children}</div>
  );
};

export default NavItem;
